import React, { useState } from 'react';
import '../../entrydoor.css';

const InteriorDoor = ({ value, onChange, label = 'Interior Door:', disabled = false }) => {
    const [selectedInteriorDoor, setSelectedInteriorDoor] = useState(value || "White");

    const handleInteriorDoorChange = (e) => {
        setSelectedInteriorDoor(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="InteriorDoor">{label}</label>
            <select
                disabled={disabled}
                id="InteriorDoor"
                value={selectedInteriorDoor}
                onChange={handleInteriorDoorChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedInteriorDoor === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{selectedInteriorDoor === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default InteriorDoor;
